<template>
  <div class="box">
    {{str}}
  </div>
</template>

<script>
export default {
    props:{str:String},
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped lang='less'>
.box {
    margin-top: 12px;
    width: 100%;
    padding: 0 12px;
    font-size: 12px;
    color:#666;
    line-height:16.8px;
}
</style>
